import { validatePresence } from 'ember-changeset-validations/validators';
import { validateUniqueness } from 'uplisting-frontend/validators/unique';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const CustomPropertyAttributeValidation = {
  name: [
    customMessageValidator(
      'custom_property_attribute_name',
      validatePresence({
        presence: true,
      }),
    ),
    customMessageValidator(
      'unique_custom_property_attribute',
      validateUniqueness(),
    ),
  ],

  description: [
    customMessageValidator(
      'custom_property_attribute_description',
      validatePresence({
        presence: true,
      }),
    ),
  ],
};
